import { ref } from 'vue';
import { formatTournamentGroup } from '@/core/oddsApi/helpers/formatTournamentGroup';
import { useTournamentGroupsQuery } from '@/core/oddsApi/oddsApiType';
import type { IGroup } from '@/interface/tournamentCenter';

export function useTournamentGroups(leagueId: number) {
    const groups = ref<IGroup[]>([]);

    const { onResult, loaded } = useTournamentGroupsQuery(
        { query: { leagueId } },
        { pollInterval: 60000 },
    );

    onResult((result) => {
        groups.value = result?.map(formatTournamentGroup) ?? [];
    });

    return { groups, loaded };
}
